export function createStoreKey(key?: string) {
    return key || ''
}
